import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';

const signedOutClients = new WeakSet<ApolloClient>();

// `ConfigQuery` caches `currentUser`. Without one there is no session to
// expire: an auth-only field on a public page must not send a logged-out
// visitor (or Googlebot) to sign-in.
export const hasSignedInUser = (client: ApolloClient) =>
  !signedOutClients.has(client) &&
  !!(client.cache.extract() as NormalizedCacheObject).ROOT_QUERY?.currentUser;

// Kept outside the cache: changing `currentUser` there makes mounted queries
// refetch and suspend on the next broadcast.
export const forgetSignedInUser = (client: ApolloClient) => {
  signedOutClients.add(client);
};

export const rememberSignedInUser = (client: ApolloClient) => {
  signedOutClients.delete(client);
};
